import { Badge, Button, Flex, FormControl, FormHelperText, FormLabel, HStack, Input, Modal, ModalBody, ModalCloseButton, ModalContent, ModalHeader, ModalOverlay, Select, SimpleGrid, Stack, Text, Textarea, useDisclosure } from '@chakra-ui/react';
import { EmptyTable, LoadingTable } from '../../components';
import React, { useEffect } from 'react';
import { addService, getServices } from '../../store/actions';
import { useAppDispatch, useAppSelector } from '../../hooks';

import { ServiceCard } from './components';
import { ToastContainer } from 'react-toastify';
import { addServiceFormValidation } from '../../utils';
import { serviceType } from '../../types';
import { useFormik } from 'formik';

export const ViewServices = () => {

    const { isOpen, onOpen, onClose } = useDisclosure();

    const { company } = useAppSelector(state => state.companyReducer);
    const { services, is_adding_service, is_loading_services } = useAppSelector(state => state.servicesReducer);

    const dispatch = useAppDispatch();

    const addServiceForm = useFormik({
        initialValues: {
            name: '',
            description: '',
            is_active: true,
        },
        validationSchema: addServiceFormValidation,
        validateOnBlur: true,
        onSubmit: (values: serviceType) => {
            const company_id = company?.company_id;
            const newValues = { ...values, company_id };
            dispatch(addService(newValues)).then(() => { onClose(); addServiceForm.resetForm(); });
            // alert(JSON.stringify(newValues));
        },
    });

    const getActiveServicesCount = () => services?.filter((service: serviceType) => service?.is_active == true)?.length;

    useEffect(() => {
        dispatch(getServices());
    }, []);

    return (
        <>
            <Flex justifyContent={'center'}>
                <Stack bg={'white'} borderRadius={6} p={6} maxW={'5xl'}>
                    <HStack justifyContent={'space-between'}>
                        <Text fontSize={'xl'} fontWeight={'medium'}>Services <Badge colorScheme={'green'}>Active services ({getActiveServicesCount()})</Badge></Text>
                        <Button size={'sm'} colorScheme={'yellow'} onClick={onOpen}>Add Service</Button>
                    </HStack>
                    <Text pb={6} color={'gray.500'}>These services will dispaly on your website, once it has been setup.</Text>
                    <SimpleGrid columns={[1, 2, 3, 3]} spacing={4} minW={{ md: '800px' }}>
                        {
                            !is_loading_services && services?.map((service: serviceType, index: number) => <ServiceCard key={index} service={service} />)
                        }
                    </SimpleGrid>
                    {is_loading_services && <LoadingTable />}
                    {!services?.length && !is_loading_services && <EmptyTable title="No services." description="Your company doesn't have any services, feel free to add some!" />}
                </Stack>
                <Modal isOpen={isOpen} onClose={onClose}>
                    <ModalOverlay />
                    <ModalContent>
                        <ModalHeader>Add Service</ModalHeader>
                        <ModalCloseButton />
                        <ModalBody>
                            <form onSubmit={addServiceForm.handleSubmit}>
                                <Stack mb={3}>
                                    <FormControl isRequired>
                                        <FormLabel>Name</FormLabel>
                                        <Input name='name' value={addServiceForm.values.name} onChange={addServiceForm.handleChange} />
                                        {addServiceForm.errors.name && <Text color={'red.500'} fontSize={'sm'}>{addServiceForm.errors.name}</Text>}
                                    </FormControl>
                                    <FormControl isRequired>
                                        <FormLabel>Active</FormLabel>
                                        <Select name='is_active' value={`${addServiceForm.values.is_active}`} onChange={addServiceForm.handleChange}>
                                            <option value={'true'}>True</option>
                                            <option value={'false'}>False</option>
                                        </Select>
                                        {addServiceForm.errors.is_active && <Text color={'red.500'} fontSize={'sm'}>{addServiceForm.errors.is_active}</Text>}
                                    </FormControl>
                                    <FormControl pb={3} isRequired>
                                        <FormLabel>Description</FormLabel>
                                        <Textarea name='description' value={addServiceForm.values.description} onChange={addServiceForm.handleChange} />
                                        <FormHelperText textAlign={'right'}>{addServiceForm.values.description.length}/80</FormHelperText>
                                        {addServiceForm.errors.description && <Text color={'red.500'} fontSize={'sm'}>{addServiceForm.errors.description}</Text>}
                                    </FormControl>
                                    <Button
                                        mt={4}
                                        type='submit'
                                        colorScheme={'yellow'}
                                        isDisabled={!addServiceForm.isValid || is_adding_service}
                                        loadingText={'Submitting...'}
                                        isLoading={is_adding_service}
                                    >
                                        Submit
                                    </Button>
                                </Stack>
                            </form>
                        </ModalBody>
                    </ModalContent>
                </Modal>
                <ToastContainer />
            </Flex>
        </>
    );
};